import { post } from "../axios";
import axios from "axios"
import Host from "../host";
const yuming = Host.host
const token = sessionStorage.getItem("token");

export default {
  // 图片域名
  getBaseImgURL() {
    let data = {
      token:token
    }
    return new Promise((resolve, reject)=>{
      axios.post(yuming + "/app/common/getOssPath",data)
      .then((success)=>{
        resolve(success.data)
      })
      .catch((error)=>{
        reject(error)
      })
    })
  },
  img_upload(file){
    let formData = new FormData();
    formData.append("file", file.file);
    formData.append('token', token);
    return new Promise((resolve, reject)=>{
      axios.post(yuming + "/app/Common/uploadImg", formData, {withCredentials: true}, {headers: {"Content-Type": "multipart/form-data"}})
      .then((success)=>{
        resolve(success)
        console.log('图片上传成功!');
      })
      .catch((error)=>{
        reject(error)
      })
    })
  }
 
};



// WEBPACK FOOTER //
// ./src/Interface/api/common.js